import { render, staticRenderFns } from "./TheFooter.vue?vue&type=template&id=6eb3e32a&scoped=true&"
var script = {}
import style0 from "./TheFooter.vue?vue&type=style&index=0&id=6eb3e32a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb3e32a",
  null
  
)

export default component.exports